export default function home_playlists() {
	
  $('.block-playlists .owl-carousel').owlCarousel({
    items: 1,
    dotsEach: false,
    dots: false,
    loop: true,
    nav: true,
    autoplay: false,
    smartSpeed: 1000,
    mouseDrag: true,
    touchDrag: true,
    navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
  });
	
}